export const styles = theme => ({
    formControl: {
        margin: "1",
        width: "100%"
    },
    aCInputRoot: {
        '&&[class*="MuiOutlinedInput-root"] input': {
            padding: 18
        }
    },
    aCOption: {
        backgroundColor: "white"
    },
    aCListbox: {
        backgroundColor: "white"
    },
    checkbox: {
        marginRight: 2,
        justifyItems: "center"
    }
});
